import { Link } from "react-router-dom";
import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [subscribing, setSubscribing] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubscribing(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email: email.trim() });
      toast.success(data.message === "Already on the list" ? "You're already on the list." : "Welcome to memoirs.");
      setEmail("");
    } catch (err) {
      toast.error(err?.response?.data?.detail?.[0]?.msg || "Could not subscribe — check the address");
    } finally {
      setSubscribing(false);
    }
  };

  return (
    <footer
      data-testid="site-footer"
      className="border-t mt-32"
      style={{ borderColor: "var(--rs-border)", background: "var(--rs-surface)" }}
    >
      <div className="px-6 md:px-12 lg:px-16 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-1">
          <div className="font-serif-display text-3xl text-bone mb-4">Ram Shack</div>
          <p className="text-muted-bone text-sm leading-relaxed max-w-xs" spellCheck={false}>
            Adult novelties for grown-ups with taste. Hand-curated. Discreetly
            shipped. Unapologetically sensual.
          </p>
        </div>

        <div>
          <div className="overline mb-5">Shop</div>
          <ul className="space-y-3">
            <li><Link to="/shop/lingerie" className="text-muted-bone hover:text-bone text-sm">Lingerie</Link></li>
            <li><Link to="/shop/toys" className="text-muted-bone hover:text-bone text-sm">Pleasure Objects</Link></li>
            <li><Link to="/shop/accessories" className="text-muted-bone hover:text-bone text-sm">Accessories</Link></li>
            <li><Link to="/shop/wellness" className="text-muted-bone hover:text-bone text-sm">Wellness</Link></li>
            <li><Link to="/shop/games" className="text-muted-bone hover:text-bone text-sm">Games</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline mb-5">Villa</div>
          <ul className="space-y-3">
            <li><Link to="/journal" className="text-muted-bone hover:text-bone text-sm" data-testid="footer-journal-link">The Journal</Link></li>
            <li><a href="#" className="text-muted-bone hover:text-bone text-sm">Discreet Shipping</a></li>
            <li><a href="#" className="text-muted-bone hover:text-bone text-sm">Returns</a></li>
            <li><a href="#" className="text-muted-bone hover:text-bone text-sm">Contact</a></li>
            <li>
              <Link
                to="/privacy"
                className="text-muted-bone hover:text-bone text-sm"
                data-testid="footer-privacy-link"
              >
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link
                to="/terms"
                className="text-muted-bone hover:text-bone text-sm"
                data-testid="footer-terms-link"
              >
                Terms of Service
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <div className="overline mb-5">Letters from the Villa</div>
          <p className="text-muted-bone text-sm mb-4">
            Slow notes, new arrivals, and the occasional confession.
          </p>
          <form
            data-testid="newsletter-form"
            className="flex border"
            onSubmit={subscribe}
            style={{ borderColor: "var(--rs-border)" }}
          >
            <input
              data-testid="newsletter-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@address.com"
              className="flex-1 bg-transparent px-4 py-3 text-sm text-bone placeholder:text-muted-bone outline-none"
            />
            <button
              data-testid="newsletter-submit-btn"
              type="submit"
              disabled={subscribing}
              className="px-5 text-xs uppercase tracking-[0.22em] text-bone disabled:opacity-50"
              style={{ background: "var(--rs-oxblood)" }}
            >
              {subscribing ? "…" : "Subscribe"}
            </button>
          </form>
        </div>
      </div>

      <div
        className="px-6 md:px-12 lg:px-16 py-4 border-t"
        style={{ borderColor: "var(--rs-border)" }}
      >
        <p className="text-[11px] text-muted-bone/80 leading-relaxed max-w-4xl" data-testid="footer-compliance-warning" spellCheck={false}>
          <span className="uppercase tracking-[0.16em]">Warning:</span> this website contains
          sexually oriented adult products and graphics. You must be at least 18 years of age —
          or 21 where that is the applicable minimum legal age in your jurisdiction — to use this
          site. If you are under the applicable minimum legal age, or if sexually oriented
          material offends you in any way, you must immediately disconnect from this website.
        </p>
      </div>

      <div
        className="px-6 md:px-12 lg:px-16 py-6 border-t flex flex-col sm:flex-row items-center justify-between gap-4"
        style={{ borderColor: "var(--rs-border)" }}
      >
        <div className="text-xs text-muted-bone tracking-wider">
          © {new Date().getFullYear()} Ram Shack — All rights reserved. 18+ only.
        </div>
        <div className="text-xs text-muted-bone tracking-[0.18em] uppercase">
          Discreet · Encrypted · Worldwide
        </div>
      </div>
    </footer>
  );
};

export default Footer;
